export const iconFontAwesomeCampingPersonShelter = (
	<i className="fa-solid fa-person-shelter"></i>
);
